function t(t=""){return""===t?"":parseFloat(String(t)).toFixed(4)}export{t as convertPriceEEC};
//# sourceMappingURL=convertPriceEEC.js.map
